import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons';
import Tooltip from './Tooltip';
import styles from './HelpTooltip.module.scss';
import MarkdownItem from '../MarkdownItem';

const HelpTooltip = ({ title, markdown, ...props}) => (
  <span className={styles.helpText}>
    {title ? (
      <Tooltip title={markdown ? <MarkdownItem>{title}</MarkdownItem> : title} {...props}>
        <FontAwesomeIcon
          size="xs"
          icon={faInfoCircle}
          className={'fa-1x'}
        />
      </Tooltip>
    ) : null}
  </span>
);

export default HelpTooltip;
